module.exports = __webpack_public_path__ + "static/media/icon_autonomo.29633ca3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_autonomo.svg
// module id = 323
// module chunks = 0